// src/components/GlobalBackground.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import WAVES from "vanta/dist/vanta.waves.min.js";
import * as THREE from "three";

export default function GlobalBackground() {
  const { pathname } = useLocation();
  const elRef = useRef(null);
  const vantaRef = useRef(null);

  useEffect(() => {
    // Disable global WAVES on /about (About has its own background)
    if (pathname === "/about") {
      vantaRef.current?.destroy?.();
      vantaRef.current = null;
      return;
    }

    // Create (or recreate) WAVES if needed
    if (!vantaRef.current && elRef.current) {
      vantaRef.current = WAVES({
        el: elRef.current,
        THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: false,
        minHeight: 200.0,
        minWidth: 200.0,
        scale: 1.0,
        scaleMobile: 1.0,
        waveHeight: 30,
        waveSpeed: 0.6,
        zoom: 0.9,
        shininess: 35,
        color: 0x0f171c,
        backgroundColor: 0x0a0a0a,
      });
    }

    // Cleanup on route change/unmount
    return () => {
      vantaRef.current?.destroy?.();
      vantaRef.current = null;
    };
  }, [pathname]);

  // Don't even render the element on /about
  if (pathname === "/about") return null;

  return (
    <div
      ref={elRef}
      className="vanta-fixed"
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: -1,
        pointerEvents: "none",
      }}
    />
  );
}





